import {Component, OnInit} from '@angular/core';

@Component({
  selector: 'app-not-found',
  template: `
    <app-public-layout>
      <p>What you are looking for could not be found</p>
    </app-public-layout>
  `,
  styles: [`
    p {
      text-align: center;
    }
  `]
})
export class NotFoundComponent implements OnInit {

  constructor() {
  }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// /var/www/dnata-cerf-front-end/releases/20200326161233/src/app/modules/public/not-found/not-found.component.ts